import { connect } from "react-redux";
import Address from "../components/Address";

const mapStateToProps = ({ Ticket, Dimension, Misc }) => ({
    countryListLoading: Dimension.Country.fetching.loading,
    countryList: Dimension.Country.countryList,

    //Misc
    language: Misc.Settings.language
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Address);
